import channel from './customer/channel'
import leaveMessage from './customer/leave-message'
import satisfaction from './customer/satisfaction'
import chat from './customer/chat'

let baseUrlCustomer = process.env.NODE_ENV == 'development' ?  '/artificial-app' : location.origin + '/artificial-app'
let baseUrlAdmin = process.env.NODE_ENV == 'development' ?  '/admin' : location.origin + '/admin'

export default {
  channel: channel(baseUrlCustomer),
  leaveMessage: leaveMessage(baseUrlCustomer),
  satisfaction: satisfaction(baseUrlCustomer),
  chat: chat(baseUrlCustomer)
}
